import React from "react";

import { Flex, Heading, List } from "@catchoftheday/cg-components";

import { NavigationItem } from "../../../../types";
import { ItemPath } from "../../utilities/analytics";
import { MenuLink } from "../MenuLink";

type TopBrandsProps = {
  topBrands: NavigationItem[];
  itemPathShop: ItemPath[];
  brandPosition: number;
};

export const TopBrands = ({
  topBrands,
  itemPathShop,
  brandPosition,
}: TopBrandsProps) => {
  return (
    <Flex
      width="20%"
      flexDirection="column"
      justifyContent="flex-start"
      bg="ui.backgroundColor"
      pt="70px"
      pb="60px"
      px="30px"
    >
      <Heading.h5
        borderBottom="solid 1px"
        borderBottomColor="ui.borderColor"
        mt="0px"
        mb="10px"
        lineHeight="1.2rem"
        pb="4px"
      >
        Top Brands
      </Heading.h5>
      <List m="0">
        {topBrands.map((brand, index) => (
          <MenuLink
            key={brand.id}
            navItem={brand}
            itemPathLink={[
              ...itemPathShop,
              {
                name: "Top Brands",
                id: itemPathShop[0].id,
                position: brandPosition,
              },
              { name: brand.name, id: brand.id, position: index + 1 },
            ]}
          />
        ))}
      </List>
    </Flex>
  );
};
